module.exports = __webpack_public_path__ + "static/media/lightCamera.fe41ff25.svg";